<div class="dialog">
    <h2>{{ data.title }}</h2>
    <mat-dialog-content>
      <ng-container [ngComponentOutlet]="data.dialogContent"> </ng-container>
    </mat-dialog-content>
    <mat-dialog-content>
      <ng-container [ngTemplateOutlet]="data.dialogContent"> </ng-container>
    </mat-dialog-content>
  </div>
  